export default __webpack_public_path__ + "static/media/background.80743d59.webp";